import { PurchaseInfo } from "../../components/mypage/PurchaseHistory";
import { Method } from "../Config";
import { ResponseType, Gateway } from "./Gateway";
import { ListSearchReqBody } from "./MapGateway";

interface DecodeParams {
    code: string;
}

interface PasswordQueryParams {
    password: string;
    newPassword?: string;
}

interface PasswordResetParams {
    code: string;
    newPassword: string;
}

interface UserIdReqBody {
    name: string;
    birth: string;
    sex: string;
}

interface UserInfoNotLogInReqParam {
    address: string;
    host: string;
}

interface UserInfoReqBody {
    username: string;
    emailNotification: number;
}

interface UpgradeQueryParams {
    impUID: string;
    merchantUID: string;
    customerUID: string;
}

interface UserActivityQueryParams {
    mapid: string;
    XID?: string;
    SID?: string;
}

class UserGateway extends Gateway {
    protected readonly _contextPath = "user";
    protected readonly _pathParams?: { [key: string]: string };
    protected readonly _processParams = {
        purchaselist: "purchaselist",
        info: "info",
        mymap: "mymap",
        update: "update",
        updatepassword: "updatepassword",
        resetpassword: "resetpassword",
        upgrade: "upgrade",
        refund: "refund",
        unsubscribe: "unsubscribe",
        delete: "delete",
        // 💠 25.03.24.MON | YoungJun | getuserid, decode process 추가
        getuserid: "getuserid",
        decode: "decode",

    };

    // GET
    public async reqPurchaseList(): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.purchaselist,
        };

        return await this.request(Method.GET, undefined, queryParam);
    }

    // 💠 25.03.25.TUE | YoungJun | decode process 추가
    public async reqDecode(param: DecodeParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.decode,
            ...param,
        };

        return await this.request(Method.GET, undefined, queryParam);
    }

    // POST
    public async reqUserData(): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.info,
        };

        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqUserDataNotLogIn(param: UserInfoNotLogInReqParam): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.info,
            ...param,
        };

        return await this.request(Method.POST, undefined, queryParam);
    }

    // 💠 25.03.24.MON | YoungJun | getuserid process 추가
    public async reqUserId(body: UserIdReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.getuserid,
        };

        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqUpdateUserInfo(body: UserInfoReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.update,
        };
        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqUserMapList(body: ListSearchReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.mymap,
        };
        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqUpdatePassword(param: PasswordQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.updatepassword,
            ...param,
        };
        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqResetPassword(param: PasswordResetParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.resetpassword,
            ...param,
        };
        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqUpgrade(param: UpgradeQueryParams) {
        const queryParam = {
            process: this._processParams.upgrade,
            ...param,
        };

        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqRefund(param: PurchaseInfo) {
        const queryParam = {
            process: this._processParams.refund,
            ...param,
        };
        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqDeleteUser(param: PasswordQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.delete,
            ...param,
        };
        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqUnsubscribe() {
        const queryParam = {
            process: this._processParams.unsubscribe,
        };
        return await this.request(Method.POST, undefined, queryParam);
    }


    //activity
    public async reqUpdateUserActivity(param: UserActivityQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.update,
            ...param,
        };

        return await this.request(Method.POST, "activity", queryParam);
    }
}

export { UserGateway, type DecodeParams, type UserInfoReqBody, type UserIdReqBody, type PasswordQueryParams, type PasswordResetParams, type UpgradeQueryParams, type UserActivityQueryParams, type UserInfoNotLogInReqParam };
